import React from 'react';
import Icon from '../../../components/icon/icon';
import Button from '../../../components/button/button';
import PropTypes from 'prop-types';
import '../style';

const Banner = (props) =>{
  const {
    icon,
    title,
    content,
    ctaIcon,
    cta,
    ctaType,
    onClick,
  } = props;
  return(
    <div className='flex flex-col gap-9 p-9 bg-grey-5 w-full items-center rounded-[20px]'>
      <div className='flex flex-col gap-6 items-center'>
        <Icon 
          children={icon}
          type='square'
        />
        <div className='flex flex-col gap-1 items-center'>
          <div className='heading-24' >{title}</div>
          <div className='text-16'>{content}</div>
        </div>
      </div>
      {cta && 
      (<Button
        iconLeft={ctaIcon? ctaIcon :''}
        children={cta}
        type={ctaType? ctaType: 'primary'}
        onClick={onClick}
      />)
      }

    </div>
  );
};

Banner.propTypes = {
  icon:PropTypes.node,
  title:PropTypes.string.isRequired,
  content:PropTypes.string.isRequired,
  ctaIcon:PropTypes.node,
  cta:PropTypes.string,
};
Banner.defaultProps = {
  icon:null,
  ctaIcon:null,
  cta:'',
};
export default Banner;